import { z } from 'zod';
import { VENDOR_TYPES } from './enums.js';
import { booleanQuery, idSchema } from './common.schema.js';
/** Polish tax identifier: exactly 10 digits once separators are stripped. */
const nipSchema = z
    .string()
    .transform((value) => value.replace(/[\s-]/g, ''))
    .refine((value) => value === '' || /^\d{10}$/.test(value), {
    message: 'NIP musi składać się z 10 cyfr',
})
    .transform((value) => (value === '' ? null : value));
export const vendorSchema = z.object({
    id: idSchema,
    name: z.string(),
    nip: z.string().nullable(),
    type: z.enum(VENDOR_TYPES),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    isActive: z.boolean(),
});
export const createVendorSchema = z.object({
    name: z.string().min(2, 'Podaj nazwę kontrahenta').max(160),
    nip: nipSchema.nullish(),
    type: z.enum(VENDOR_TYPES).default('SUPPLIER'),
    email: z.string().email('Nieprawidłowy adres e-mail').nullish().or(z.literal('')),
    phone: z.string().max(32).nullish(),
    address: z.string().max(240).nullish(),
});
export const updateVendorSchema = createVendorSchema
    .partial()
    .extend({ isActive: z.boolean().optional() });
export const vendorListQuerySchema = z.object({
    search: z.string().trim().optional(),
    type: z.enum(VENDOR_TYPES).optional(),
    includeInactive: booleanQuery(false),
});
//# sourceMappingURL=vendor.schema.js.map